import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { Route, Routes } from 'react-router-dom';
import Header from './VendorC/Header';
import PrSider from './VendorC/PrSider';
import Dashboard from '../pages/provider/Dashboard';
import VendorstartForm from '../pages/provider/VendorstartForm/VendorstartForm';
import useAuthStore from '../store/authStore';
import Services from '../pages/provider/Services/Services';
import Calendar from '../pages/provider/Calendar/Calendar';
import Clients from '../pages/provider/Clients/Clients';
import Employees from '../pages/provider/Employees/Employees';
import Orders from '../pages/provider/Orders/Orders';
import Settings from '../pages/provider/Settings/Settings';
import Moliya from '../pages/provider/Buxgalter/Moliya';
import TarifStatus from '../pages/provider/TarifStatus/TarifStatus';
import SingleServiceMain from '../pages/provider/Services/ServiceSingle/SingleServiceMain';
import Foods from '../pages/provider/Foods/Foods';


const ProviderLayout = () => {
  return (
    <Layout style={{ minHeight: '100vh', background: 'var(--qk-bg)' }}>
      <Header />
      <Layout style={{ display: 'grid', gridTemplateColumns: '80px 1fr' }}>
        <PrSider />
        <Content
          style={{
            padding: 24,
            minHeight: 'calc(100vh - 56px)',
            background: 'var(--qk-bg)',
          }}
        >
          <div style={{ maxWidth: '1920px', margin: '0 auto' }}>
            <Prroutes />
          </div>
        </Content>
      </Layout>

    </Layout>
  );
};

export default ProviderLayout;


function Prroutes() {
  const { user } = useAuthStore();
  const started = user?.isvendor === 1;

  if (!started) {
    return <VendorstartForm />;
  }

  return (
    <Routes>
      <Route path='/' element={<Dashboard />} />
      <Route path='/services' element={<Services />} />
      <Route path='/services/service/:id' element={<SingleServiceMain />} />
      <Route path='/employees' element={<Employees />} />
      <Route path='/calendar' element={<Calendar />} />
      <Route path='/clients' element={<Clients />} />
      <Route path='/orders' element={<Orders />} />
      <Route path='/foods' element={<Foods />} />
      <Route path='/settings' element={<Settings />} />
      <Route path='/moliya' element={<Moliya />} />
      <Route path='/tarif' element={<TarifStatus />} />
    </Routes>
  );
}
